<template>
    <b-card-footer footer-bg-variant="dark" class="footer">
        Copyright 2020, Willian Nascimento®
    </b-card-footer>
</template>

<script>
export default {
    name: "Footer"

}
</script>

<style>

.footer{
  text-align: center;
  bottom: 0;
  margin-top: 10px;
  border-radius: 0%;
  color: white;
}

</style>